import { makeStyles } from '@material-ui/core';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {},
    title: {},
    selector: {},
    loadingFromUrl: {
      fontWeight: theme.typography.fontWeightRegular,
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(16),
      color: COLORS.gray.gray40,
      marginBottom: theme.spacing(1),
    },
    loadingRow: {
      display: 'flex',
      flexDirection: 'row',
      gap: theme.spacing(0.5),
    },
    singleDot: {
      width: 3,
      height: 3,
    },
    dots: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-end',
      marginBottom: theme.spacing(1),
    },
    collapsedPersona: {
      border: theme.shape.borderGray60,
      borderRadius: theme.shape.borderRadiusSmall,
      backgroundColor: COLORS.gray.gray90,
      color: COLORS.gray.gray50,
      padding: theme.spacing(1.5, 2),
      marginTop: theme.spacing(-0.5),
    },
  }),
  {
    name: 'BlockPersonas',
  }
);
